export default "__VITE_ASSET__Cicxdhec__"